module.exports = __webpack_public_path__ + "static/media/Sharon.209b81d0.png";